var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: { title: _vm.$t("home.bookCancel"), isShowFollow: false },
              on: { open: _vm.opened },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "filter-container-content" }, [
              _c(
                "div",
                { staticStyle: { margin: "10px 20px 0" } },
                [
                  _c("p", { staticClass: "content-tips" }, [
                    _vm._v(_vm._s(_vm.$t("home.cancelBookingConfirmMsg"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: {
                        rules: _vm.rules,
                        "label-position": "top",
                        model: _vm.form,
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "reqired is-required",
                                  attrs: {
                                    label: _vm.$t("home.reason"),
                                    prop: "reason",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      rows: 8,
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.form.reason,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "reason", $$v)
                                      },
                                      expression: "form.reason",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "text-align": "right" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            "text-align": "center",
                            margin: "20px 10px",
                            width: "100px",
                          },
                          attrs: { type: "primary" },
                          on: { click: _vm.handelCancelBooking },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("btn.confirm")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            "text-align": "center",
                            margin: "20px 0",
                            width: "100px",
                          },
                          attrs: { type: "primary" },
                          on: { click: _vm.handleClose },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("home.buttonClose")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("cancelBookingListMsg", {
        ref: "cancelBookingListMsg",
        attrs: {
          width: "60%",
          cancelBookingListMsg: _vm.cancelBookingListMsg,
          visible: _vm.cancelBookingListMsgVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.cancelBookingListMsgVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }